import { Component, Input } from '@angular/core';
import { ModalService } from '../../../../shared/components/modal/modal.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/utils/services/auth.service';
import { LoadingService } from 'src/app/shared/components/loading/loading.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register-user',
  templateUrl: './register-user.component.html',
  styleUrls: ['./register-user.component.scss']
})
export class RegisterUserComponent {

  @Input() data;
  form: FormGroup;

  constructor(
    private modalService: ModalService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private loadingService: LoadingService,
    private route: Router,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required, Validators.maxLength(50)]],
      email: [this.data ? this.data : null, [Validators.required, Validators.email]],
    });
  }

  onSubmit(): void {
    this.loadingService.active();
    const user = {
      name: this.form.value.name,
      email: this.form.value.email.toLowerCase().trim(),
    }
    const now = new Date();
    const userHistoric = {
      ...user,
      date: this.getDateNow(),
      hour: `${now.getHours() < 10 ? '0'+now.getHours() : now.getHours()}:${now.getMinutes() < 10 ? '0'+now.getMinutes() : now.getMinutes()}`,
    };

    this.authService.authUser(user.email);
    const subscription$: Subscription = this.authService.authenticatedUser$.subscribe(isUsuarioJaExiste => {
      if (isUsuarioJaExiste) {
        alert('Este e-mail já está cadastro. Tente acessar novamente ou contate o suporte.');
        this.onClose();
        this.loadingService.disactive();
        subscription$.unsubscribe();
      } else {
        subscription$.unsubscribe();
        this.cadastraNovoUser(user, userHistoric);
      }
    });
  }

  private cadastraNovoUser(user, userHistoric) {
    this.authService.registerNewUser(user, userHistoric);
    const subscription$: Subscription = this.authService.authenticatedNewUser$.subscribe(result => {
      if (result) {
        this.route.navigate(['/home']);
      } else {
        alert('Erro ao cadastrar usuário. Entre em contato com o suporte.');
        this.onClose();
        this.loadingService.disactive();
      }
      this.onClose();
      subscription$.unsubscribe();
    });
  }

  private getDateNow(): string {
    const now = new Date;
    const day = now.getDate() < 10 ? ("0" + now.getDate()).slice(-2) : now.getDate();
    const month = now.getMonth() < 10 ? ("0" + (now.getMonth() + 1)).slice(-2) : now.getMonth();
    const year = now.getFullYear();
    return day + '/' + month + "/" + year;
  }

  onClose() {
    this.modalService.closeModal();
  }
}
